import React from "react";
import PropTypes from "prop-types";

import BaseInput from "./base-input";

function EmailWidget(props) {
  return <BaseInput type="email" {...props} />;
}

if (process.env.NODE_ENV !== "production") {
  EmailWidget.propTypes = {
    value: PropTypes.string,
  };
}

export default EmailWidget;



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/widgets/email-widget.js